// extracted by mini-css-extract-plugin
export var listDesigners = "otherDesigners-module--listDesigners--3k8gC";
export var otherDesigner = "otherDesigners-module--otherDesigner--23vV7";
export var otherDesignerImage = "otherDesigners-module--otherDesignerImage--39OCB";
export var image = "otherDesigners-module--image--AKuQ5";
export var otherDesignerText = "otherDesigners-module--otherDesignerText--1k0QD";